module.exports = __webpack_public_path__ + "static/media/JavaScript_logo.dd60b11e.svg";